<template>
  <div>
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h2 class="card-title">Candy Cane</h2>
              <p class="category">*Christmas 2019 Gifts*</p>
            </div>
            <div class="card-content">
              <img src="../../../../../static/img/CandyCane/IMG_3942.jpg" alt="A group of 4 candy canes illuminated" style="border-radius:30px;margin-bottom:20px">
              <p>Apparently I just keep building gifts for Christmas...so this is the present that I built for Christmas 2019! :D  It's a Bluetooth controlled Candy Cane.  Play it as an instrument, let it play christmas songs to you, or just use it as a night light for some wicked LED fun! If you want to build one, the code and design files can be found <a href="https://github.com/mclemcrew/Candy-Cane-Christmas-2019" target="_blank">here!</a></p>
            </div>
          </div>
        </div>
  </div>
  <!-- YouTube Demos -->
  <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Candy Cane Demo</h4>
            </div>
            <div class="card-content">
              <youtube :video-id="videoIdOne" ref="youtube" @playing="playing"></youtube>
            </div>
          </div>
        </div>
  </div>

  <!-- Demo Stuff -->
  <div class="row">
      <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Built With</h4>
            </div>
            <div class="card-content">
              <ul style="font-size:15px">
                <li>[Arduino Nano] - The microcontroller used</li>
                <li>[WS2812B RGB 5050 LED Strip] – LEDs inside the snowflake</li>
                <li>[SPDT (Single Pole, Double Throw) Switch]</li>
                <li>[HM10 Bluetooth Module]</li>
                <li>[1" speaker]</li>
                <li>[9V Battery]</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">CAD Model</h4>
            </div>
            <div class="card-content">
              <p>The necessary STL files are provided <a href="https://github.com/mclemcrew/Candy-Cane-Christmas-2019/tree/master/STL-Parts" target="_blank">here</a> so you can print your own candy cane! Feel free to modify it how you see fit! :D</p>
            </div>
          </div>
        </div>
    </div>

    <!-- Demo Stuff -->
  <div class="row">
      <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Circuit Diagram</h4>
            </div>
            <div class="card-content">
              <p>Obviously there are more LEDs than listed in the diagram, but hopefully it's not too confusing to follow</p>
              <img src="../../../../../static/img/CandyCane/circuit.jpg" alt="A group of 4 snowflakes illuminated" style="margin-bottom:20px">
            </div>
          </div>
        </div>
    </div>

    <!-- Gallery -->
    <div class="row">
        <div class="col-lg-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Gallery</h4>
            </div>
            <div class="card-content" style="display: flex;
                  flex-flow: row wrap;
                  justify-content: center;">
              <!-- Image Gallery -->
              <gallery :images="images" :index="index" @close="index = null"></gallery>
              <div
                class="image"
                v-for="(image, imageIndex) in images"
                :key="imageIndex"
                @click="index = imageIndex"
                :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
              ></div>
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  data () {
    return {
      videoIdOne: 'd6HXOgdGlIA',
      videoIdTwo: 'gu9hagKKioA',
      images: [
        '../../../../../static/img/CandyCane/1.jpg',
        '../../../../../static/img/CandyCane/2.jpg',
        '../../../../../static/img/CandyCane/3.jpg',
        '../../../../../static/img/CandyCane/4.jpg',
        '../../../../../static/img/CandyCane/5.jpg',
        '../../../../../static/img/CandyCane/6.jpg',
        '../../../../../static/img/CandyCane/7.jpg'
      ],
      index: null
    }
  },
  methods: {
    playVideo () {
      this.player.playVideo()
    },
    playing () {
      console.log('/\\o/ we are watching!!!')
    }
  },
  computed: {
    player () {
      return this.$refs.youtube.player
    }
  },
  components: {
    'gallery': VueGallery
  }
}
</script>
<style>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
.image {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Projects/CandyCane.vue